import { PickSessionViewSchema } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getPickSessionFilters = {
  name: "getPickSessionFilters" as const,
  input: z.object({}),
  output: z.object({ filters: z.array(PickSessionViewSchema) }),
};
